module.exports = __webpack_public_path__ + "static/media/gears.253c6e09.svg";